import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BlogPreview from "../components/blogPreview.js"
import Pager from "../components/pager.js"

const Blog = ({ data, pageContext }) => {
  const blogPosts = data.allMarkdownRemark

    return (
        <Layout>
            <SEO title="Blog" />
            <div className="container-fluid mt-3">
                <h1 className="text-center">Blog posts</h1>
                {blogPosts.edges.map(({node}) => (
                  <BlogPreview
                    key={node.id}
                    title={node.frontmatter.title}
                    slug={node.fields.slug}
                    image={node.frontmatter.featuredImage.childImageSharp.fluid}
                    excerpt={node.frontmatter.excerpt}
                    date={node.frontmatter.date}
                  />
                ))}
            </div>
          <Pager pageContext={pageContext} />
        </Layout>
    )
}



Blog.propTypes = {
    data: PropTypes.object.isRequired,
    pageContext: PropTypes.object.isRequired,
}

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}, skip: $skip, limit: $limit, filter: {fileAbsolutePath: {regex: "\\\\/blog/"}}) {
        edges {
            node {
                id
                frontmatter {
                    title
                    date(formatString: "Do MMM Y")
                    excerpt
                    featuredImage {
                        childImageSharp {
                            fluid(maxWidth: 750) {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                }
                fields {
                    slug
                }
            }
        }
    }
  }
`

export default Blog